import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import { SCREEN_WIDTH_DESKTOP } from 'src/components/constants';
import siteSetting from 'src/siteSetting';

const BackgroundContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primaryColor,
}));

const AuthFooter = styled('div')({
  position: 'absolute',
  bottom: 0,
  width: '100%',
});

const LogoImage = styled('img')(({ theme }) => ({
  height: '55px',
  objectFit: 'contain',
  width: siteSetting.themeWebsiteLogoWidth(),
  [theme.breakpoints.down('sm')]: {
    height: 45,
  },
}));

const FakeButton = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    width: 40,
  },
}));

const ContentContainer = styled('div')(({ theme }: { theme: Theme }) => ({
  padding: 28,
  maxWidth: '86vw',
  flex: 1,
  minWidth: 'calc(100vw - 250px)!important',
  [theme.breakpoints.down('md')]: {
    minWidth: '100vw !important',
  },
  [theme.breakpoints.down(SCREEN_WIDTH_DESKTOP)]: {
    padding: 12,
    maxWidth: '100vw',
  },
}));

export {
  FakeButton,
  BackgroundContainer,
  AuthFooter,
  LogoImage,
  ContentContainer,
};
